import React from "react";
import { Modal, Button } from "antd";
import { Icon } from "@iconify/react";

interface PaymentConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  orderTotal: string;
  orderReference: string;
}

const PaymentConfirmationModal: React.FC<PaymentConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  orderTotal,
  orderReference,
}) => {
  return (
    <Modal
      title={
        <div className="flex items-center text-xl">
          <Icon
            icon="mdi:cash-register"
            className="mr-2 text-primary text-2xl"
          />
          Confirm Payment
        </div>
      }
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div className="py-4">
        <div className="bg-blue-50 p-4 rounded-lg mb-4">
          <p className="font-medium text-blue-700">Important Information</p>
          <p className="text-blue-600 text-sm mt-1">
            You are about to confirm that payment has been received for this
            order. This action cannot be undone.
          </p>
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex justify-between border-b pb-2">
            <span className="text-gray-600">Order Reference:</span>
            <span className="font-semibold">{orderReference}</span>
          </div>
          <div className="flex justify-between border-b pb-2">
            <span className="text-gray-600">Payment Method:</span>
            <span className="font-semibold">Cash</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Total Amount:</span>
            <span className="font-semibold text-lg">{orderTotal}</span>
          </div>
        </div>

        <div className="flex justify-end space-x-3 mt-6">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" onClick={onConfirm} className="bg-primary">
            Confirm Payment
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentConfirmationModal;
